module.exports = __webpack_public_path__ + "static/media/icon.arrow.down.b03ffad3.svg";